import { Box } from '@mui/material';
import { useRef, useEffect } from 'react';

import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-json';
import { learnMoreCreatorSelectors } from 'redux/slices/learnMoreCreatorSlice';
import { surveyCreatorSelectors } from 'redux/slices/surveyCreatorSlice';

interface JsonPreviewProps {
  previewType: 'learnMore' | 'survey';
}

const JsonPreview = ({ previewType }: JsonPreviewProps) => {
  const content =
    previewType === 'learnMore'
      ? learnMoreCreatorSelectors.useSelectLearnMoreCurrentContent()
      : surveyCreatorSelectors.useSelectSurveyCreatorCurrentContent();

  const codeRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (codeRef.current) {
      Prism.highlightElement(codeRef.current);
    }
  }, [content]);

  const formattedJson = JSON.stringify(content, null, 2);

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '8px',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          flex: 1,
          backgroundColor: '#2d2d2d',
          borderRadius: '8px',
          padding: '16px',
          boxSizing: 'border-box',
          overflowX: 'none',
          width: '100%',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#1e1e1e',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#666',
            borderRadius: '4px',
            '&:hover': {
              background: '#888',
            },
          },
        }}
      >
        <pre
          style={{
            margin: 0,
          }}
        >
          <code ref={codeRef} className="language-json">
            {formattedJson}
          </code>
        </pre>
      </Box>
    </Box>
  );
};

export default JsonPreview;
